export default __webpack_public_path__ + "static/media/quiz_answer.10b011df.jpg";